// From https://stackoverflow.com/a/76022384/6939540
// And https://github.com/handlebars-lang/handlebars.js/issues/1207
import Handlebars from 'handlebars';

import { EMPTY_ARRAY } from '@e-socna/empty';

const getVariablesFromStatementsRecursive = (
  statements: readonly hbs.AST.Statement[],
) =>
  statements.reduce((acc: readonly string[], statement) => {
    const { type } = statement;
    const newAcc = acc.slice();

    if ('BlockStatement' === type) {
      const { inverse, program } = statement as hbs.AST.BlockStatement;

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (program?.body) {
        newAcc.push(...getVariablesFromStatementsRecursive(program.body));
      }

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (inverse?.body) {
        newAcc.push(...getVariablesFromStatementsRecursive(inverse.body));
      }
    } else if ('MustacheStatement' === type) {
      const { path } = statement as hbs.AST.MustacheStatement;

      if ('original' in path && path.original) {
        newAcc.push(path.original);
      }
    }

    return newAcc;
  }, EMPTY_ARRAY);

export const getHandlebarsVariables = (input: string) => {
  const { body } = Handlebars.parseWithoutProcessing(input);

  return getVariablesFromStatementsRecursive(body);
};
